import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ArticleIcon from '@mui/icons-material/Article';
import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionIcon from '@mui/icons-material/Description';
import InsightsIcon from '@mui/icons-material/Insights';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import PhonelinkSetupIcon from '@mui/icons-material/PhonelinkSetup';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import AddCardIcon from '@mui/icons-material/AddCard';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import SyncIcon from '@mui/icons-material/Sync';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { Box } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useEffect, useRef, useState, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { Loader } from "./components/common/Loader";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import MainContent from "./components/MainContent/MainContent";
import PreventBackNavigation from "./pages/PreventBackNavigation";
import { setTitle } from "./redux/actions/dashboardTitle";
import { checkTokenExpiry } from "./utils/authUtils";
import { getHeaderRoles } from "./redux/actions/HeaderRoles/GetHeaderRolesSlice";
import { ModuleRegistry } from "ag-grid-community";
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { setTabName } from "./redux/actions/SupportTicket/tabSlice";
import EngineeringIcon from '@mui/icons-material/Engineering';

// LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-089652}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{The_Coca_Cola_Company}_is_granted_a_{Multiple_Applications}_Developer_License_for_{20}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_August_2026}____[v3]_[01]_MTc4ODEzMDgwMDAwMA==cb959b9bfde93226378489360e0ff3d9");
ModuleRegistry.registerModules([AllEnterpriseModule.with(AgChartsEnterpriseModule)]);
LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-065772}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{The_Coca_Cola_Company}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Topline_Forecast}_only_for_{6}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Topline_Forecast}_need_to_be_licensed___{Topline_Forecast}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{21_September_2025}____[v3]_[0102]_MTc1ODQwOTIwMDAwMA==372521b73ce277d3fad471863dd69994");

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {

          '&.Mui-focused .MuiOutlinedInput-notchedOutline ': {
            borderColor: '#000',  // Your desired border color
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            borderColor: '#000',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#000',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#000',
          },
        },
      },
    },
    MuiMultiSectionDigitalClockSection: {
      styleOverrides: {
        item: {
          "&.Mui-selected": {
            backgroundColor: '#000',
          },
          "&.Mui-selected:hover": {
            backgroundColor: '#797979'
          }
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#797979'
        },
      },
    },

  },
});

function App() {
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const title = useSelector((state) => state?.dashboardDetails?.title);
  const tabDetails = useSelector((state) => state?.dashboardDetails?.tabDetails);
  const isAuthenticated = useIsAuthenticated();
  const [menuItems, setMenuItems] = useState([

  ]);
  const [mdmMenuItems, setMdmMenuItems] = useState([]);
  const [appStoredRoles, setAppStoredRoles] = useState([]);
  const [loaderFlag, setLoaderFlag] = useState(false);
  const { instance, accounts, inProgress } = useMsal();

  const storedRoles = (data) => {
    setAppStoredRoles(data)
  }

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      instance?.handleRedirectPromise()
        .then((response) => {
          if (response) {
            processLogin(response);
          } else if (accounts?.length === 0) {
            handleLogin();
          }
        })
        .catch((error) => console.log("Error during redirect:", error));
    }
  }, [instance, accounts, inProgress]);

  const queryParams = new URLSearchParams(location.search);

  const queryAppType = queryParams?.get("appType");
  const queryPlant = queryParams?.get("plant");
  const queryRole = queryParams?.get("role");
  const queryRegion = queryParams?.get("region");
  const queryPath = queryParams?.get("path");
  // sessionStorage.setItem("postLoginRedirect", window.location.pathname + window.location.search);

  const handleLogin = () => {
    const loginRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    instance?.loginRedirect(loginRequest);
  };

  const processLogin = (response) => {
    if (!response?.accessToken) return;
    localStorage.setItem("data", response?.account?.username)
    localStorage.setItem("userName", response?.account?.name);
    const isExpired = checkTokenExpiry(response?.accessToken);
    if (isExpired) {
      localStorage.clear();
      instance?.logoutRedirect();
    } else {
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("procurementDivisionType", "SIS");
      localStorage.setItem("accessToken", response?.accessToken);
      // const redirectUrl = sessionStorage.getItem("postLoginRedirect");
      if (queryAppType !== null && queryPlant !== null && queryRole !== null && queryRegion !== null && queryPath !== null) {
        getuserRoles()
      } else {
        navigate("/landing-page");
      }
    }
  };

  useEffect(() => {
    if (tabDetails.title === "Landing") {
      setMenuItems(menuItems)
      setMdmMenuItems(mdmMenuItems)
    }
  }, [tabDetails])

  const getuserRoles = async () => {
    setLoaderFlag(true);
    try {
      const responseHeaderRoles = await dispatch(getHeaderRoles({
        dynamicEndpoint: 'api/user/fetch-user-details',
      }));
      if (responseHeaderRoles?.meta?.requestStatus === 'fulfilled') {

        const rolesObj = responseHeaderRoles?.payload?.userRoles;
        if (queryAppType === "LT") {
          const matched = rolesObj?.LT?.find(
            (item) =>
              item?.plant === queryPlant &&
              item?.cokeRegion === queryRegion &&
              item?.roles?.some((r) => r === queryRole)
          );

          if (matched) {
            const newUrl = `/${queryPath}`

            setTimeout(() => {
              const ltPlantOptionsResp = rolesObj?.LT?.filter(region => region?.cokeRegion === queryRegion);
              const LTData = JSON.stringify(ltPlantOptionsResp);
              localStorage.setItem("LTPlantOptions", LTData);
              localStorage.setItem("activeCard", 0);
              localStorage.setItem("approverActiveItem", "Pending Approval");
              localStorage.setItem("workflowActiveItem", "Pending Action");
              localStorage.setItem("lastVisitedPage", 0);
              localStorage.setItem("reportsActiveItem", "Lead Time Variations at Component Level");
              localStorage.setItem("cardTitle", "Lead Time Analytics");

              localStorage.setItem("selectedLTPlant", matched?.plant);
              localStorage.setItem("LTRole", queryRole);
              localStorage.setItem("LTRegion", matched?.cokeRegion);
              localStorage.setItem("LTplantType", matched?.plantType);
              localStorage.setItem("selectedLTPlantCode", queryPlant);
              localStorage.setItem("LTPathName", (queryRole === "Planner" && matched?.plantType === "CPS") ? "/lt-dashboard" : (queryRole === "Admin" && matched?.plantType === "CPS") ? "/run-analytics-scheduler" : (queryRole === "Approver" && matched?.plantType === "CPS") ? "/approval-management" : (queryRole === "Planner" && matched?.plantType === "DPS") ? "/DPS-Planner-analytics" : (queryRole === "Viewer" && matched?.plantType === "CPS") ? "/viewer-analytics-results" : (queryRole === "GMP" && matched?.plantType === "CPS") ? "/gmp-dashboard" : "");
              window.location.href = newUrl;
            }, 300)
          }
        }
        else if (queryAppType === "CD") {
          const matched = rolesObj?.CD?.find(
            (item) =>
              item?.plant === queryPlant &&
              item?.cokeRegion === queryRegion &&
              item?.roles?.some((r) => r === queryRole)
          );

          if (matched) {
            const newUrl = `/${queryPath}`

            setTimeout(() => {
              const cdPlantsData = rolesObj?.CD?.filter(item => item?.cokeRegion === queryRegion);
              const CDData = JSON.stringify(cdPlantsData);
              localStorage.setItem("CDPlantOptions", CDData);
              localStorage.setItem("activeCard", 0);
              localStorage.setItem("approverActiveItem", "Pending Approval");
              localStorage.setItem("workflowActiveItem", "Pending Action");
              localStorage.setItem("lastVisitedPage", 0);
              localStorage.setItem("reportsActiveItem", "Lead Time Variations at Component Level");
              localStorage.setItem("cardTitle", "Contract Data Update");

              localStorage.setItem("selectedCDPlant", matched?.plant);
              localStorage.setItem("CDRole", queryRole);
              localStorage.setItem("CDRegion", matched?.cokeRegion);
              localStorage.setItem("CDplantType", matched?.plantType);
              localStorage.setItem("selectedCDPlantCode", queryPlant);
              localStorage.setItem("CDPathName", (queryRole === "Planner" && matched?.plantType === "CPS") ? "/price-memo" : (queryRole === "Admin" && matched?.plantType === "CPS") ? "/price-memo" : (queryRole === "Approver" && matched?.plantType === "CPS") ? "/price-memo" : (queryRole === "Planner" && matched?.plantType === "DPS") ? "/price-memo" : (queryRole === "Viewer" && matched?.plantType === "CPS") ? "/price-memo" : (queryRole === "GMP" && matched?.plantType === "CPS") ? "/price-memo" : "");
              window.location.href = newUrl;
            }, 300)
          }
        }
      }
    } catch (error) {
      console.error('API error:', error);
    }
    setLoaderFlag(false);
  }

  useEffect(() => {
    if (queryAppType !== null && queryPlant !== null && queryRole !== null && queryRegion !== null && queryPath !== null) {

      getuserRoles()
    }
  }, [queryPlant, queryRole, queryRegion, queryAppType, queryPath])


  const handleMenuItemClick = (path, label, item) => {
    navigate(path);
    localStorage.setItem("lastVisitedPage", 0);
    localStorage.setItem("workflowActiveItem", "Pending Action");
    localStorage.setItem("activeCard", 0);
    localStorage.setItem("reportsActiveItem", "Lead Time Variations at Component Level");
    dispatch(setTitle(item));
    path === "/reportings" && dispatch(setTabName("Price Memo"));
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/landing-page");
    instance.logoutRedirect();
  };

  const LTRole = localStorage.getItem("LTRole");
  const CDRole = localStorage.getItem("CDRole");
  const LTPathName = localStorage.getItem("LTPathName");
  const plantType = localStorage.getItem("LTplantType");
  const CDPlantType = localStorage.getItem("CDplantType");

  useEffect(() => {
    if (LTRole === "Admin" && plantType === "CPS") {
      setMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/run-analytics-scheduler",
          title: "Schedule Configurator",
          label: "Run Analytics & Scheduler",
          icon: <AnalyticsIcon />,
        },
        {
          id: 3,
          path: "/admin-analytics-results",
          title: "LT Analytics Results & Workflow",
          label: "LT Analytics Results & Workflow",
          icon: <QueryStatsIcon />,
        },
        {
          id: 4,
          path: "/parameter-configuration",
          title: "Parameter Configuration",
          label: "Parameter Configuration",
          icon: <PermDataSettingIcon />,
        },
        {
          id: 5,
          path: "/planner-material-mapping",
          title: "Planner Material Mapping",
          label: "Planner Material Mapping",
          icon: <PeopleAltIcon />,
        },
        {
          id: 6,
          path: "/s4datasyncstatus",
          title: "S/4 Data-Sync Status",
          label: "S/4 Data-Sync Status",
          icon: <SyncIcon />,
        },
        {
          id: 7,
          path: "/reports",
          title: "Reports",
          label: "Reports",
          icon: <DescriptionIcon />,
        },
        {
          id: 8,
          path: "/kpi-tracking",
          title: "KPI Tracking",
          label: "KPI Tracking",
          icon: <TrackChangesIcon />,
        },
        {
          id: 9,
          path: "/inventory-impact-simulation",
          title: "Inventory Impact Simulation",
          label: "Inventory Impact Simulation",
          icon: <SummarizeIcon />,
        },
        {
          id: 10,
          path: "/lt-ticketsummary",
          title: "Ticket Summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
        },
      ])
    }
    if (LTRole === "Admin" && plantType === "DPS") {
      setMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/run-analytics-scheduler",
          title: "Schedule Configurator",
          label: "Run Analytics & Scheduler",
          icon: <AnalyticsIcon />,
        },
        {
          id: 3,
          path: "/DPS-analytics",
          title: "DPS Analytics Results",
          label: "DPS Analytics Results",
          icon: <PermDataSettingIcon />,
        },
        {
          id: 4,
          path: "/planner-material-mapping",
          title: "Planner Material Mapping",
          label: "Planner Material Mapping",
          icon: <PermDataSettingIcon />,
        },
        {
          id: 5,
          path: "/reports",
          title: "Reports",
          label: "Reports",
          icon: <DescriptionIcon />,
        },
        {
          id: 6,
          path: "/kpi-tracking",
          title: "KPI Tracking",
          label: "KPI Tracking",
          icon: <TrackChangesIcon />,
        },
        {
          id: 7,
          path: "/inventory-impact-simulation",
          title: "Inventory Impact Simulation",
          label: "Inventory Impact Simulation",
          icon: <SummarizeIcon />,
        },
        {
          id: 8,
          path: "/lt-ticketsummary",
          title: "Ticket Summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
        },
      ])
    }
    if (LTRole === "Approver" && plantType === "CPS") {
      setMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/approval-management",
          label: "Approval Management",
          icon: <InsightsIcon />,
          title: "Approval Management",
        },
        {
          id: 3,
          path: "/reports",
          title: "Reports",
          label: "Reports",
          icon: <DescriptionIcon />,
        },
        {
          id: 4,
          path: "/kpi-tracking",
          title: "KPI Tracking",
          label: "KPI Tracking",
          icon: <TrackChangesIcon />,
        },
        {
          id: 5,
          path: "/inventory-impact-simulation",
          title: "Inventory Impact Simulation",
          label: "Inventory Impact Simulation",
          icon: <SummarizeIcon />,
        },
        {
          id: 6,
          path: "/lt-ticketsummary",
          title: "Ticket Summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
        },
      ])
    }
    if (LTRole === "Planner" && plantType === "CPS") {
      setMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/lt-dashboard",
          label: "Action Dashboard",
          icon: <DashboardIcon />,
          title: "Dashboard",
        },
        {
          id: 3,
          path: "/analytics-results",
          label: "LT Analytics Results & Workflow",
          icon: <QueryStatsIcon />,
          title: "Workflow Management",
        },
        {
          id: 4,
          path: "/s4datasyncstatus-planner",
          label: "S/4 Data-Sync Status",
          icon: <SyncIcon />,
          title: "S/4 Data-Sync Status",
        },
        {
          id: 5,
          path: "/reports",
          title: "Reports",
          label: "Reports",
          icon: <DescriptionIcon />,
        },
        {
          id: 6,
          path: "/kpi-tracking",
          title: "KPI Tracking",
          label: "KPI Tracking",
          icon: <TrackChangesIcon />,
        },
        {
          id: 7,
          path: "/inventory-impact-simulation",
          title: "Inventory Impact Simulation",
          label: "Inventory Impact Simulation",
          icon: <SummarizeIcon />,
        },
        {
          id: 8,
          path: "/lt-ticketsummary",
          title: "Ticket Summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
        },
      ])

    }
    if (LTRole === "Planner" && plantType === "DPS") {
      setMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/DPS-Planner-analytics",
          label: "DPS Analytics Results",
          icon: <QueryStatsIcon />,
          title: "DPS Analytics Results",
        },
        {
          id: 3,
          path: "/reports",
          title: "Reports",
          label: "Reports",
          icon: <DescriptionIcon />,
        },
        {
          id: 4,
          path: "/kpi-tracking",
          title: "KPI Tracking",
          label: "KPI Tracking",
          icon: <TrackChangesIcon />,
        },
        {
          id: 5,
          path: "/inventory-impact-simulation",
          title: "Inventory Impact Simulation",
          label: "Inventory Impact Simulation",
          icon: <SummarizeIcon />,
        },
        {
          id: 6,
          path: "/lt-ticketsummary",
          title: "Ticket Summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
        },
      ])

    }
    if (LTRole === "Viewer" && plantType === "CPS") {
      setMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/viewer-analytics-results",
          title: "LT Analytics Results & Workflow",
          label: "LT Analytics Results & Workflow",
          icon: <QueryStatsIcon />,
        },
        {
          id: 3,
          path: "/run-analytics-scheduler",
          title: "Schedule Configurator",
          label: "Run Analytics & Scheduler",
          icon: <AnalyticsIcon />,
        },
        {
          id: 4,
          path: "/parameter-configuration",
          title: "Parameter Configuration",
          label: "Parameter Configuration",
          icon: <PermDataSettingIcon />,
        },
        {
          id: 5,
          path: "/planner-material-mapping",
          title: "Planner Material Mapping",
          label: "Planner Material Mapping",
          icon: <PeopleAltIcon />,
        },
        {
          id: 6,
          path: "/s4datasyncstatus",
          title: "S/4 Data-Sync Status",
          label: "S/4 Data-Sync Status",
          icon: <SyncIcon />,
        },
        {
          id: 7,
          path: "/reports",
          title: "Reports",
          label: "Reports",
          icon: <DescriptionIcon />,
        },
        {
          id: 8,
          path: "/kpi-tracking",
          title: "KPI Tracking",
          label: "KPI Tracking",
          icon: <TrackChangesIcon />,
        },
        {
          id: 9,
          path: "/inventory-impact-simulation",
          title: "Inventory Impact Simulation",
          label: "Inventory Impact Simulation",
          icon: <SummarizeIcon />,
        },
        {
          id: 10,
          path: "/lt-ticketsummary",
          title: "Ticket Summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
        },
      ])

    }
    if (LTRole === "GMP" && plantType === "CPS") {
      setMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/gmp-dashboard",
          label: "Action Dashboard",
          icon: <DashboardIcon />,
          title: "Dashboard",
        },
        {
          id: 3,
          path: "/gmp-analytics-results",
          label: "LT Analytics Results & Workflow",
          icon: <QueryStatsIcon />,
          title: "Workflow Management",
        },
        {
          id: 4,
          path: "/gmp-s4datasyncstatus",
          label: "S/4 Data-Sync Status",
          icon: <SyncIcon />,
          title: "S/4 Data-Sync Status",
        },
        {
          id: 5,
          path: "/reports",
          title: "Reports",
          label: "Reports",
          icon: <DescriptionIcon />,
        },
        {
          id: 6,
          path: "/kpi-tracking",
          title: "KPI Tracking",
          label: "KPI Tracking",
          icon: <TrackChangesIcon />,
        },
        {
          id: 7,
          path: "/inventory-impact-simulation",
          title: "Inventory Impact Simulation",
          label: "Inventory Impact Simulation",
          icon: <SummarizeIcon />,
        },
        {
          id: 8,
          path: "/lt-ticketsummary",
          title: "Ticket Summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
        },
      ])

    }
    if (CDRole === "Viewer" && CDPlantType === "CPS") {
      setMdmMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/cd-dashboard",
          label: "Dashboard",
          icon: <DashboardIcon />,
          title: "Dashboard",
        },
        {
          id: 3,
          path: "/price-memo",
          label: "Price Memo",
          icon: <RequestQuoteIcon />,
          title: "Price Memo",
        },
        {
          id: 4,
          path: "/contracts",
          label: "Contracts",
          icon: <PhonelinkSetupIcon />,
          title: "Contracts",
        },
        {
          id: 5,
          path: "/reportings",
          label: "Reportings",
          icon: <ArticleIcon />,
          title: "Reportings",
        },
        {
          id: 6,
          path: "/contract-maintenance",
          label: "Contract Maintenance",
          icon: <AddCardIcon />,
          title: "Contract Maintenance",
        },
        {
          id: 7,
          path: "/cm-reports",
          label: "Contract Maintenance Report",
          icon: <ArticleIcon />,
          title: "Contract Maintenance Report",
        },
         {
          id: 8,
          path:"/quota-maintenance",
          label: "Quota Maintenance",
          icon: <EngineeringIcon />,
          title: "Quota Maintenance",
        },
        {
        id: 9,
        path: "/ticket-summary",
        label: "Ticket Summary",
        icon: <SummarizeIcon />,
        title: "Ticket Summary",
        }
      ])
    } else if ((CDRole === "Price Memo Owner (Packaging)" || CDRole === "Price Memo Owner (CEPG)" ) && CDPlantType === "CPS") {
      setMdmMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/pricememo-management",
          label: "Price Memo Mgmt",
          icon: <ManageAccountsIcon />,
          title: "Price Memo Mgmt",
        },
        {
          id: 3,
          path: "/audit-logs",
          label: "Audit Logs",
          icon: <ManageAccountsIcon />,
          title: "Audit Logs",
        },
         {
          id: 4,
          path:"/quota-maintenance",
          label: "Quota Maintenance",
          icon: <EngineeringIcon />,
          title: "Quota Maintenance",
        },
         {
          id: 5,
          path: "/ticket-summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
          title: "Ticket Summary",
        },
      ])
    } else if (( CDRole === "Price Memo Viewer (Packaging)" ) && CDPlantType === "CPS") {
      setMdmMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/packaging-viewer-pricememo",
          label: "Price Memo Mgmt",
          icon: <ManageAccountsIcon />,
          title: "Price Memo Mgmt",
        },
        {
          id: 3,
          path: "/audit-logs",
          label: "Audit Logs",
          icon: <ManageAccountsIcon />,
          title: "Audit Logs",
        },
        {
          id: 4,
          path:"/quota-maintenance",
          label: "Quota Maintenance",
          icon: <EngineeringIcon />,
          title: "Quota Maintenance",
        },
         {
          id: 5,
          path: "/ticket-summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
          title: "Ticket Summary",
        },
      ])
    } else if (( CDRole === "Price Memo Viewer (CEPG)" ) && CDPlantType === "CPS") {
      setMdmMenuItems([
        {
          id: 1,
          path: "/landing-page",
        },
        {
          path: "/packaging-viewer-pricememo",
          label: "Price Memo Mgmt",
          icon: <ManageAccountsIcon />,
          title: "Price Memo Mgmt",
        },
        {
          id: 3,
          path: "/audit-logs",
          label: "Audit Logs",
          icon: <ManageAccountsIcon />,
          title: "Audit Logs",
        },
        {
          id: 4,
          path:"/quota-maintenance",
          label: "Quota Maintenance",
          icon: <EngineeringIcon />,
          title: "Quota Maintenance",
        },
         {
          id: 5,
          path: "/ticket-summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
          title: "Ticket Summary",
        },
      ])
    } else if ((CDRole === "Analyst" || CDRole === "Planner" || CDRole === "MOP") && CDPlantType === "CPS") {
      setMdmMenuItems([
        {
          id: 1,
          path: "/landing-page",
          title: "Landing",
        },
        {
          id: 2,
          path: "/cd-dashboard",
          label: "Dashboard",
          icon: <DashboardIcon />,
          title: "Dashboard",
        },
        {
          id: 3,
          path: "/price-memo",
          label: "Price Memo",
          icon: <RequestQuoteIcon />,
          title: "Price Memo",
        },
        {
          id: 4,
          path: "/contracts",
          label: "Contracts",
          icon: <PhonelinkSetupIcon />,
          title: "Contracts",
        },
        {
          id: 5,
          path: "/reportings",
          label: "Reportings",
          icon: <ArticleIcon />,
          title: "Reportings",
        },
        {
          id: 6,
          path: "/contract-maintenance",
          label: "Contract Maintenance",
          icon: <AddCardIcon />,
          title: "Contract Maintenance",
        },
        {
          id: 7,
          path: "/cm-reports",
          label: "Contract Maintenance Report",
          icon: <ArticleIcon />,
          title: "Contract Maintenance Report",
        },
         {
          id: 8,
          path:"/quota-maintenance",
          label: "Quota Maintenance",
          icon: <EngineeringIcon />,
          title: "Quota Maintenance",
        },
        {
          id: 9,
          path: "/ticket-summary",
          label: "Ticket Summary",
          icon: <SummarizeIcon />,
          title: "Ticket Summary",
        },
      ])
    }
  }, [tabDetails, LTRole, CDRole, CDPlantType, plantType]);

  const aribaMenuItems = [
    {
      id: 1,
      path: "/landing-page",
      title: "Landing",
    },
    {
      id: 2,
      path: "/ar-dashboard",
      label: "Dashboard",
      icon: <DashboardIcon />,
      title: "Dashboard",
    },
  ];

  useEffect(() => {
    let getTitle = menuItems.filter((item) =>
      item.path.includes(location.pathname)
    );
    let getmdmTitle = mdmMenuItems?.filter((item) =>
      item.path.includes(location.pathname)
    );
    let getAribaTitle = aribaMenuItems?.filter((item) =>
      item.path.includes(location.pathname)
    );
    (getTitle[0] && dispatch(setTitle(getTitle[0]))) ||
      (getmdmTitle[0] && dispatch(setTitle(getmdmTitle[0]))) ||
      (getAribaTitle[0] && dispatch(setTitle(getAribaTitle[0])));
    // eslint-disable-next-line
  }, [location.pathname, dispatch, LTRole, CDRole, LTPathName]);

  useLayoutEffect(() => {
    let animationFrameId;

    const measure = () => {
      if (headerRef.current) {
        const height = headerRef.current.offsetHeight;

        if (height > 0) {
          setHeaderHeight(height);
        } else {
          animationFrameId = window.requestAnimationFrame(measure);
        }
      } else {
        animationFrameId = window.requestAnimationFrame(measure);
      }
    };

    animationFrameId = window.requestAnimationFrame(measure);

    window.addEventListener("resize", measure);

    return () => {
      window.removeEventListener("resize", measure);
      window.cancelAnimationFrame(animationFrameId);
    };
  }, [tabDetails, LTRole, CDRole]);

  return (
    (isAuthenticated && accounts?.[0] && !loaderFlag) ? <Box
      sx={{
        margin: "auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <PreventBackNavigation />
      <ThemeProvider theme={theme}>
        <Header
          headerRef={headerRef}
          title={title}
          handleLogout={handleLogout}
          handleMenuItemClick={handleMenuItemClick}
          storedRoles={storedRoles}
        />
        <Box
          sx={{
            paddingTop: `${headerHeight}px`,
            transition: "padding-top 0.3s ease",
          }}
        >
          <MainContent
            contentHeight={headerHeight}
            handleMenuItemClick={handleMenuItemClick}
            menuItems={menuItems}
            mdmMenuItems={mdmMenuItems}
            aribaMenuItems={aribaMenuItems}
          />
        </Box>
        <Footer />
        <ToastContainer />
      </ThemeProvider>
    </Box>
      :
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: "center" }}>
        <Loader />
      </div>
  );
}

export default App;
